/* Custom script for Disney Cruise Line brand v2.0.0 */
/* Includes all devices (mobile/desktop) */
/* Author: Lindsay Prahalad/Tom Nelson, October 2015 */

// -------------------------------------------------------------------------------------------------------------------

// Manage modal dialog

// Display overlay for on request rooms that can only be booked via the call centre; user can disimss
function call() {
// Dialog is dismissable
dismissable = true;
$('#dialog').addClass('dismissable');
// Add request class to dialog
$('#dialog').addClass('request has-image');
// Show dialog
modal('#call',false);
}

// Display overlay for themed offline deals
function offlineDeal() {
    // Dialog is dismissable
    dismissable = true;
    $('#dialog').addClass('dismissable');
    // Add class to dialog
    $('#dialog').addClass('offline-cta has-image');
    // Show dialog
    modal('#offline-cta', false);
}
// -------------------------------------------------------------------------------------------------------------------

// Generic

// Track modal by click source via GA event
$('.homepage .call').click(function() { GA.sendEvent('Book','Enquiry','Cruise (Homepage)'); });
$('section:not(.deal) + aside .launch .button').click(function() { GA.sendEvent('Book','Enquiry','Cruise (Sidebar)'); });
$('section:not(.deal) a.launch, section:not(.deal) .synopsis .button').click(function() { GA.sendEvent('Book','Enquiry','Cruise (Package)'); });
$('.desktop nav dd.book, .desktop nav li.book > a').click(function() { GA.sendEvent('Book','Enquiry','Cruise (Header)'); });
$('.mobile nav dd.book').click(function() { GA.sendEvent('Book','Enquiry','Cruise (Off-Canvas)'); });

// Deal pages
$('.deal + aside .button').click(function() { GA.sendEvent('Book','Enquiry','Cruise (Deal Sidebar)'); });
$('.deal .synopsis .button').click(function() { GA.sendEvent('Book','Enquiry','Cruise (Deal Package)'); });
$('.deal a.launch, .deal .launch .button').click(function() { GA.sendEvent('Book','Enquiry','Cruise (Deal Shallow Launch)'); });
// Themed modal
$('#themed-modal .launch').click(function (event) { event.preventDefault(); offlineDeal(); });
// -------------------------------------------------------------------------------------------------------------------

// On ready
$(document).ready(function() {

// -------------------------------------------------------------------------------------------------------------------

// Generic

// Show CTA popup
$('.homepage .call, .launch .button, .synopsis .button, a.launch, .desktop nav dd.book, .show-modal' ).click(function() { call(); });

// Show CTA modal when 'Prices & Booking' in off-canvas nav is tapped (mobile only)
$('.mobile nav dd.book').click(function() {
snap(); // Snap off-canvas closed
call(); // Show popup
});

// Pause billboard when modal is displayed
$('.homepage .call').click(function() { billboard.slick('slickPause'); });

});

